<div class="customizer-content" [perfectScrollbar] *ngIf="bikes">
    <div class="customizer-header px-2 pt-1 pb-0 position-relative">
        <h4 class="mb-0">Vélos disponibles</h4>
        <a class="customizer-close" (click)="toggleSidebar('bike-sidebar')">
            <span [data-feather]="'x'"></span>
        </a>
    </div>
    <hr />
    <div class="text-center" *ngIf="bikes.length == 0">Aucun vélo disponible</div>
    <div *ngFor="let bike of bikes">
        <div class="text-center">
            <img src="{{ apiUrl }}/uploads/{{ bike.principal_image }}" width="160" />
            <h6 class="mt-1">{{bike.reference}} {{bike.category_title}} {{bike.kind}} - {{bike.size}}</h6>
            <hr />
        </div>
    </div>
</div>